<template>
  <div>
    <v-dialog width="60%" scrollable v-model="contrato.showDiagRegistrar" :fullscreen="$vuetify.breakpoint.xsOnly">
      <v-card>
        <v-card-title>
          Registrar nova ocorrência para o contrato
          <v-spacer></v-spacer>
          <v-btn icon @click="contrato.showDiagRegistrar = !contrato.showDiagRegistrar">
            <v-icon>mdi-close-box</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pa-9 pt-0 pb-2">
          <v-row>
            <template>
              <strong>CNPJ: {{contrato.CNPJ}}</strong>
            </template>
          </v-row>
          <v-row>
            <template>
              <strong>Razão Social: {{contrato.RazaoSocial}}</strong>
            </template>
          </v-row>
          <v-row>
            <template>
              <strong>Tipo de Contrato: {{`${tipoContrato(contrato.TipoContrato)}`}}</strong>
            </template>
          </v-row>
          <v-row>
            <template>
              <strong>Data: {{`${$moment(contrato.VigenciaInicio).format('L')}`}}</strong>
            </template>
          </v-row>
        </v-card-text>
        <v-row>
          <v-col class="pl-9 pb-0" cols="6">
            <v-select
                :items="contrato.situacaoList"
                v-model="contrato.Situacao"
                item-text="Descricao"
                item-value="IdSituacao"
                label="Situação"
                hide-details
                outlined
                dense
            ></v-select>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="pl-5 pr-5 pt-0" cols="12">
            <v-card-text>
              <v-textarea v-model="ocorrenciaDescricao" auto-grow label="Descrição da ocorrência"></v-textarea>
            </v-card-text>
          </v-col>
        </v-row>
        <v-card-actions class="mr-4">
          <v-spacer></v-spacer>
          <v-btn @click="contrato.showDiagRegistrar = !contrato.showDiagRegistrar" dark>cancelar</v-btn>
          <v-btn @click="cadOcorrencias()" color="primary" dark>registrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog width="60%" scrollable v-model="contrato.showDiagVisualizar" :fullscreen="$vuetify.breakpoint.xsOnly">
      <v-card>
        <v-card-title>
          Linha do tempo do contrato
          <v-spacer></v-spacer>
          <v-btn icon @click="contrato.showDiagVisualizar = !contrato.showDiagVisualizar">
            <v-icon>mdi-close-box</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pa-9 pt-0 pb-0">
          <v-row>
            <template>
              <strong>CNPJ: {{contrato.CNPJ}}</strong>
            </template>
          </v-row>
          <v-row>
            <template>
              <strong>Razão Social: {{contrato.RazaoSocial}}</strong>
            </template>
          </v-row>
          <v-row>
            <template>
              <strong>Tipo de Contrato: {{`${tipoContrato(contrato.TipoContrato)}`}}</strong>
            </template>
          </v-row>
          <v-row>
            <template>
              <strong>Data: {{`${$moment(contrato.VigenciaInicio).format('L')}`}}</strong>
            </template>
          </v-row>
          <v-timeline
              align-top
              :dense="$vuetify.breakpoint.smAndDown"
          >
            <v-timeline-item
                v-for="(item, i) in contrato.ocorrenciasList"
                :key="i"
                :color="item.color"
                :icon="item.icon"
                fill-dot
            >
              <v-card
                  :color="item.color"
                  dark
              >
                <v-card-title class="text-h6">
                  {{item.Step}}
                </v-card-title>
                <v-card-text class="white text--primary pb-1 pt-4">
                  <p>Usuário: {{item.Usuario}}</p>
                  <p>{{item.tituloData}}: {{`${$moment(item.dataCronologica).format('LLL')}`}}</p>
                  <p>{{item.tituloDesc}}: {{item.Descricao}}</p>
                  <p v-if="item.Observacao != '' && item.Observacao != null">Observação: {{item.Observacao}}</p>
                </v-card-text>
              </v-card>
            </v-timeline-item>
          </v-timeline>

        </v-card-text>
      </v-card>
    </v-dialog>
    <AlertSystem :snackbar="system.snackbar"></AlertSystem>
  </div>
</template>

<script>
import AlertSystem from './AlertSystem.vue'
export default {
  name: "OcorrenciasProcessoTermo",
  props: {
    contrato: {
      IdContrato: Number,
      Situacao: Number,
      CNPJ: String,
      RazaoSocial: String,
      TipoContrato: String,
      VigenciaInicio: String,
      showDiagRegistrar: Boolean,
      showDiagVisualizar: Boolean,
      situacaoList: Array,
      ocorrenciasList: Array,
    },
  },
  components: {
    AlertSystem
  },
  data: () => ({
    system: {
      snackbar: {},
    },
    // Ocorrências
    diagEvidencias: false,
    diagLinhaDoTempo: false,
    situacaoSelecionado: null,
    ocorrenciasCredenciados: [],
    ocorrenciaDescricao: "",
    ocorrenciasList: [],
  }),
  methods: {
    cadOcorrencias(){
      this.axios.post(`termos/${this.contrato.IdContrato}/ocorrencias`, {
        ocorrenciaDescricao: this.ocorrenciaDescricao,
        IdSituacao: this.contrato.Situacao
      }).then(res => {
        this.system.snackbar = {
          snackbar: true,
          text: res.data,
          color: "green",
        };
        this.diagEvidencias = false
        this.ocorrenciaDescricao = ''
        this.contrato.showDiagRegistrar = false
        this.$emit('atualiza-termos')
      }).catch(e=>{
        this.system.snackbar = {
          snackbar: true,
          text: e.response.data[Object.keys(e.response.data)[0]][0],
          color: "red",
        };
      })
      this.contrato.showDiagRegistrar = false;
    },
    tipoContrato(contratoTipo) {
      switch (Number(contratoTipo)) {
        case 1: return 'Portal de Serviços';
        case 2: return 'Termo de Acatamento';
        case 3: return 'Outros';
        case 4: return 'Indústria Mais Segura';                
      }
    }
  },
}
</script>

<style>
</style>